export const MuiDialogActions = {
  styleOverrides: {
    root: {
      padding: '16px 24px',
    },
  },
};
